// Third Controls
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRealtimeTags } from 'Core/hooks';
import { MapUtilitiesTypes } from '../MapUtilitiesMenu/enums';

import { useIntl } from 'react-intl';
import { Button, SearchInput, Tooltip } from '@gpstrackit/gtc-react-controls';
//import './style.scss';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FlagIcon from '@mui/icons-material/Flag';
import FormatShapesIcon from '@mui/icons-material/FormatShapes';
import { convertWhiteColor } from 'Core/data/Helpers';
import styles from 'Assets/sass/core/vars.scss';

//Actions
import { 
  selectModuleMapSettings, 
  setHiddenTags, 
  hideLandmarkGroups, 
  hideGeofenceGroups, 
  savePreference 
} from "Redux/actions";

import './style.scss';

const TagFilterAppliedMenu = (props) => {

    const dispatch = useDispatch();
    const { messages } = useIntl();

    //states
    const [searchText, onSearchText] = useState()
    const [preferencesItems, setPreferencesItems] = useState()

    //vars
    const preferencesKey = 'realtimeMaps';

    //selectors
    const tagsVehicleList = useSelector(state => state.realtimeMapUtilitiesVehiclesListRedux.tagsVehicleList);
    const landmarkTags = useSelector((state) => state.realtimeMapLandmarkListModuleRedux.landmarkTags);
    const geofenceTags = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux.geofenceTags);
    const tagsCatalog  = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags', 'color', 'parentId'] });
    const returnServer = useSelector(state => state.preferencesRedux.returnServer);
    const preferencesUser = useSelector(state => state.preferencesRedux.preferencesUser);
    const authenticatedId = useSelector(state => state.securityRedux.authenticatedId);
    

    const haveUntagged = tagsCatalog?.find(t => t?.id == -1) ? true : false;

    const untaggedItem = {
      id: -1,
      name: messages['untagged'],
      label: messages['untagged'],
      visible: true,
      open: true,
      color: styles?.color_untagged,
      unitgroupname: 'None',
      unitgroupcolor: styles?.color_untagged,
      path: null,
      items: []
    }

    let vehicleTagList = [
      ...tagsVehicleList,
      haveUntagged ? { ...untaggedItem } : null
    ].filter((item) => item != null);

    let landmarkTagList = [
      ...landmarkTags,
      haveUntagged ? { ...untaggedItem } : null
    ].filter((item) => item != null);

    let geofenceTagList = [
      ...geofenceTags,
      haveUntagged ? { ...untaggedItem } : null
    ].filter((item) => item != null);

    // combine elements and create array with all tags
    const allTagList = [...vehicleTagList, ...landmarkTagList, ...geofenceTagList];

    // result combined list without dupply elements
    const combinedList = Array.from(
      new Map(allTagList.map(tag => [tag.id, tag])).values()
    );

    const sortedListTags = combinedList.sort((a, b) => {
      // untagged group is first
      if (a.id === -1) return -1;
      // untagged group is first
      if (b.id === -1) return 1;

      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });

    /********************************************************
    * Restore initial state
    ********************************************************/
    const closeTagFilter = () => {
        dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default))
    }

    useEffect(() => {
      if (preferencesUser) {
          let preferencesKeyTemp = preferencesUser.find(x => x.preferenceKey === preferencesKey);
          let preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}";
          preferencesJSON = JSON.parse(preferencesJSON);
  
          setPreferencesItems(preferencesJSON)
      }
    }, [returnServer]);

    const showAllTags = () => {
      dispatch(setHiddenTags([]));
      dispatch(hideLandmarkGroups([]));
      dispatch(hideGeofenceGroups([]));

      //save value on preference
      const preferenceValue = { ...preferencesItems, hiddenTagsOnPreference: [], hiddenLandmarkGroups: [], hiddenGeofenceGroups: [] };
      dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: preferenceValue}));
      setPreferencesItems(preferenceValue);
    }

    if(!preferencesItems) return (<></>)

    let tagsData = searchText ? sortedListTags?.filter(({ label }) => label.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) : sortedListTags;
    const enableCloseButton = Boolean(!preferencesItems?.hiddenTagsOnPreference?.length && !preferencesItems?.hiddenLandmarkGroups?.length &&  !preferencesItems?.hiddenGeofenceGroups?.lengt)

    //filter list when not have groups active.
    tagsData = tagsData?.filter((item) => {
      if(
           (!preferencesItems?.hiddenTagsOnPreference?.includes(item.id) && vehicleTagList?.find((element) => element.id == item.id))
        || (!preferencesItems?.hiddenLandmarkGroups?.includes(item.id) && landmarkTagList?.find((element) => element.id == item.id))
        || (!preferencesItems?.hiddenGeofenceGroups?.includes(item.id) && geofenceTagList?.find((element) => element.id == item.id))
      ) 
        return true;
      return false;
    });

    return (
      <div style={{ marginTop: -30, padding: 0 }}>
          <h2 style={{ fontSize: '1.2em' }}>{messages['maputilities_tagsFilterOnMap']}</h2>
          <div style={{ marginBottom: 20 }}>
              <label className={`menuItem`} onClick={(e) => closeTagFilter()} >
                  {messages[`maputilities_back`]}
              </label>
          </div>
          <div>
            <SearchInput onSearchText={onSearchText} searchText={searchText} placeholder={messages["search"]} />
          </div>
          <div className='panelFilterTags-container' style={{ height: '65vh', overflow: "auto", padding: '20px 0px'}}>
            <ul className="panelFilterTags-list">
              { 
                tagsData && tagsData?.map((tag, index) => {
                  return(
                    <li key={`k-${index}`} className="panelFilterTags-item">
                      <div className="panelFilterTags-content">
                        <div className="panelFilterTags-icon-left">
                          <LocalOfferIcon className="panelFilterTags-icon" style={{ color: `${convertWhiteColor(tag?.color)}` }} />
                        </div>
                        <div className="panelFilterTags-label-container">
                          <span className="panelFilterTags-label">{tag.label}</span>
                        </div>
                        <div className="panelFilterTags-right-icons">
                          { 
                            /* icon vehicles */
                            ((!preferencesItems?.hiddenTagsOnPreference || !preferencesItems?.hiddenTagsOnPreference?.includes(tag.id)) && (vehicleTagList?.find((element) => element.id == tag.id) ))
                            ? ( <Tooltip
                                  placement="bottom"
                                  title={messages['mapTagFilter_tags_have_vehicles']}
                                >
                                    <DirectionsCarIcon className="panelFilterTags-icon" style={{ color: styles?.color_btn_blue }} />
                                </Tooltip>
                              ) 
                            : (<div className="panelFilterTags-icon-placeholder" />)
                          }
                          { 
                            /* icon landmark */
                            ((!preferencesItems?.hiddenLandmarkGroups || !preferencesItems?.hiddenLandmarkGroups?.includes(tag.id)) && (landmarkTagList?.find((element) => element.id == tag.id) ))
                            ? (<Tooltip
                              placement="bottom"
                              title={messages['mapTagFilter_tags_have_landmarks']}
                            >
                                <FlagIcon className="panelFilterTags-icon" style={{ color: styles?.color_btn_blue }} />
                            </Tooltip>) 
                            : (<div className="panelFilterTags-icon-placeholder" />)
                          }
                          { 
                            /* icon geofence */
                            ((!preferencesItems?.hiddenGeofenceGroups || !preferencesItems?.hiddenGeofenceGroups?.includes(tag.id)) && (geofenceTagList?.find((element) => element.id == tag.id) ))
                              ? (<Tooltip
                                placement="bottom"
                                title={messages['mapTagFilter_tags_have_geofences']}
                              >
                                <FormatShapesIcon className="panelFilterTags-icon" style={{ color: styles?.color_btn_blue }} />
                              </Tooltip>) 
                            : (<div className="panelFilterTags-icon-placeholder" />)
                          }
                        </div>
                      </div>
                      <hr className="panelFilterTags-divider" />
                    </li>
                  )
                })}
            </ul>
          </div>
          <div style={{ width: '100%', display: "flex", justifyContent: "flex-end", marginTop: 'auto', paddingTop: 20 }}>
              <Button
                  onClick={(e) => {
                    if (e) e.preventDefault();
                    //remove the marker
                    if(!enableCloseButton){
                      showAllTags()
                    }else{
                      closeTagFilter()
                    }
                    
                  }}
                  variant={!enableCloseButton ? "primary" : "secundary" }
              >
                {!enableCloseButton ? messages['mapTagFilter_showAll'] : messages['close']}
              </Button>
          </div>
    </div>
    )
}

export default TagFilterAppliedMenu;